
import {defineComponent} from 'vue';
import SiteForm from "@/components/form/SiteForm.vue";
import LichenRecordForm from "@/components/form/LichenRecordForm.vue";
import Message from "primevue/message";
import Button from "primevue/button";
import FormLegend from "@/components/legend/FormLegend.vue";
import {scrollToTop} from "@/config/app-settings";

export default defineComponent({
  components: {FormLegend, LichenRecordForm, SiteForm, Message, Button},
  name: 'Form',
  data() {
    return {
      state: 'init' as 'init' | 'submitted' | 'success' | 'error',
      cancelRequested: false,
      submitAnswer: '' as string,
    }
  },
  computed: {
    lichenRecordForm(): Object {
      return this.$store.state.lichenRecordForm
    },
    isValid(): Boolean {
      return this.$store.getters.recordsAreValid && this.$store.getters.siteIsValid
    }
  },
  methods: {
    addLichenRecord() {
      this.$store.dispatch('addLichenRecord')
    },
    initializeForm() {
      if (this.$store.state.formState == 'new') {
        this.$store.dispatch('validate', {})
        this.$store.dispatch('newLichenRecord')
        this.$store.commit('setFormState', 'editingUnsaved')
      } else {
        this.$store.commit('setFormState', 'editing')
      }
    },
    submit() {
      console.log("state.lichenRecordForm ", this.$store.state.lichenRecordForm)

      this.$store.dispatch('submitLichenRecordForm')
          .then((res: string) => {
            this.submitAnswer = res
            this.$store.dispatch('notify', res.toString())
            this.$store.dispatch('validate', {})
            this.$router.push({name: 'Home'})
            this.state = 'success'
            this.$store.commit('setFormState', 'new')
            this.$store.state.menubarClicked = false

          })
          .catch((err: any) => {
            this.state = 'error'
            console.log("err.response.data", err.response.data)
            this.$store.dispatch('validate', err.response.data)
          })
    }
    ,
    cancel() {
      this.$router.push({name: 'Home'})
      this.$store.dispatch('deleteLichenRecordForm')
      this.$store.dispatch('validate', {})
      this.cancelRequested = false
      this.$store.state.menubarClicked = false
      this.$store.commit('setFormState', 'new')
    },
  },
  beforeMount() {
    scrollToTop()
    this.initializeForm()
  }
});
